import hasBillesAccess from 'utils/hasBillesAccess'

function getAccountModuleHelper(user) {
  if (!user) return null
  let currentClient = user.currentClient
  if (currentClient.modules) {
    return currentClient.modules.reduce((acc, item) => {
      if (item.module === 'account') {
        acc = item
      }
      return acc
    }, {})
  } else {
    return null
  }
}

function getModuleByNameHelper(user, name) {
  if (!user) return null
  let currentClient = user.currentClient
  for (let i = 0; i < currentClient.modules.length; i++) {
    if (currentClient.modules[i].module === name) {
      return currentClient.modules[i]
    }
  }
  return null
}

export default function user(user) {
  let accountModule = getAccountModuleHelper(user)
  return {
    isAdmin: function() {
      if (
        hasBillesAccess(accountModule.access) ||
        accountModule.access === 'A'
      ) {
        return true
      }
      return false
    },
    isBilles: function() {
      if (hasBillesAccess(accountModule.access)) {
        return true
      }
      return false
    },
    getAccountModule: function() {
      return accountModule
    },
    getAllModules: function() {
      return user.currentClient.modules
    },
    getModuleByName: function(name) {
      return getModuleByNameHelper(user, name)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/user.js